import axios from '@plugins/axios';

class JuegoSetService {
    getList(user_id, params = {}, options = {}) {
        return axios({
            url: `operadora/institution/juego-set/${user_id}`,
            method: 'GET',
            params,
            ...options
        });
    }
    set(user_id, juego_id, data = {}, options = {}) {
        return axios({
            url: `operadora/institution/juego-set/${user_id}/${juego_id}`,
            method: 'PUT',
            data,
            ... options,
        });
    }

    delete(user_id, juego_id, options = {}) {
        return axios({
            url: `operadora/institution/juego-set/${user_id}/${juego_id}`,
            method: 'DELETE',
            ... options,
        });
    }
}

export const BaseJuegoSetService = JuegoSetService;

export default new JuegoSetService();